import { AxiosResponse } from 'axios';
import apiInterceptor from '../utils/axios';
import { Unidad } from '../types/Unidad/Unidad';

const SERV_BACK: string = process.env.REACT_APP_API_ESPOL_ADS || '';
const APIUNIDAD = 'api/Catalog/Unidad/';

export default class UnidadService {

    static async GetUnidades(): Promise<Array<Unidad>> {
        const response1: AxiosResponse<Array<Unidad>> = await apiInterceptor.get(`${SERV_BACK}${APIUNIDAD}`,
            {
                headers:{
                    "Content-type" : "application/json",
                },
            }
        );
        return response1.data;
    }

}